export default __webpack_public_path__ + "static/media/logo.a0ea0f8a.svg";